/* You can add your custom scripts here */

/* ============================================================
   FB SUPER DEAL GATE — reactivity + unlock popup
   ------------------------------------------------------------
   Rule: Super Deal products can only be added to cart when the
   cart already contains a Catálogo product.

   - Catálogo line items carry a hidden property `_fb_cat=1`
     (rendered in product-summary.liquid & section-product-processor.liquid).
   - This script watches the cart and toggles body.fb-cart-has-catalog,
     which drives all gate visibility via custom.css.
   - On the unlock transition (no-catalog -> has-catalog) it shows a
     one-time congratulations popup linking to the Super Deals collection.

   No core theme files are modified. Cart-state changes are detected by
   wrapping window.fetch and watching for the Ajax Cart API endpoints
   (/cart/add|change|update|clear) resolving — a MutationObserver on
   .cart-count is kept as a redundant backup, but proved unreliable on
   its own once Rebuy Smart Cart started owning the add-to-cart flow
   (its cart-count re-render doesn't always mutate the same node).

   Rebuy's own flyout auto-opens on every add; the client wants the cart
   to open ONLY on an explicit header-icon click, so a body-class
   observer force-closes any non-explicit open (see "Rebuy Smart Cart
   auto-open suppression" below).
   ============================================================ */
(function () {
  'use strict';

  var FB = {
    bodyClass: 'fb-cart-has-catalog',
    catalogProperty: '_fb_cat',
    superDealProperty: '_fb_sd',
    superDealsUrl: (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'collections/super-deals',
    copy: {
      emoji: '🎉',
      title: '¡Desbloqueaste los Súper Deals!',
      text: 'Ya tienes un producto del Catálogo en tu carrito. Ahora puedes agregar todos los Súper Deals que quieras.',
      cta: 'Ver Súper Deals',
      dismiss: 'Seguir comprando'
    }
  };

  var lastHasCatalog = document.body.classList.contains(FB.bodyClass);
  var popupShownThisSession = false;
  var syncing = false;

  /* ------------------------------------------------------------
     Rebuy Smart Cart auto-open suppression
     ------------------------------------------------------------
     Rebuy's own flyout (body.rebuy-cart-visible, window.Rebuy.SmartCart)
     auto-opens on every add-to-cart. The client wants the cart to open
     ONLY when a customer explicitly clicks the header cart icon; on an
     add, this gate's own popup (unlock) or nothing at all (already
     unlocked / non-catalog add) should be the only thing shown.

     Rebuy already binds its own early click handler to the header cart
     toggle to open the flyout on click (window.Rebuy._earlyCartClick*),
     so we don't need to implement click-to-open ourselves — only mark
     when a click is the reason the flyout is about to appear, so the
     body-class observer below can tell an explicit open from an auto
     one and leave explicit opens alone. */
  var explicitCartOpen = false;
  document.addEventListener('click', function (e) {
    if (e.target.closest('.section-header-cart-drawer-toggle')) {
      explicitCartOpen = true;
      setTimeout(function () { explicitCartOpen = false; }, 1500);
    }
  }, true);

  function hideRebuyCart() {
    try {
      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.hide === 'function') {
        window.Rebuy.SmartCart.hide();
      }
    } catch (e) {}
    /* Verify shortly after (Rebuy's own show may run right after ours);
       fall back to clicking its real close button, and cover the
       theme's native cart-drawer too in case Rebuy is ever removed. */
    setTimeout(function () {
      if (document.body.classList.contains('rebuy-cart-visible')) {
        var rebuyClose = document.querySelector('.rebuy-cart__flyout-close');
        if (rebuyClose) rebuyClose.click();
      }
      var drawer = document.querySelector('cart-drawer.active, cart-drawer[aria-hidden="false"]');
      if (drawer) {
        var closeBtn = drawer.querySelector('.cart-drawer-close');
        if (closeBtn) closeBtn.click();
        else { drawer.classList.remove('active'); drawer.setAttribute('aria-hidden', 'true'); }
      }
    }, 50);
  }

  new MutationObserver(function () {
    if (document.body.classList.contains('rebuy-cart-visible') && !explicitCartOpen) {
      hideRebuyCart();
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  /* Reliable cart-change signal: react to the Ajax Cart API resolving,
     rather than watching for Rebuy's own DOM updates (its cart-count
     re-render doesn't always mutate the SAME node our old MutationObserver
     watched, so that path alone missed updates in testing). */
  var fbOrigFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string' ? input : (input && input.url)) || '';
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var isCartMutation = method === 'POST' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
    var p = fbOrigFetch.apply(this, arguments);
    if (isCartMutation) {
      p.then(function (res) {
        if (res && res.ok) setTimeout(syncGate, 50);
      }).catch(function () {});
    }
    return p;
  };

  function root() {
    return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
  }
  function propTruthy(item, prop) {
    return item.properties && (item.properties[prop] === '1' || item.properties[prop] === 1 || item.properties[prop] === true);
  }

  /* Read the live cart: is a Catálogo product present, and which line items
     (by key) are Super Deals? */
  function computeCartState() {
    return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return { hasCatalog: false, sdKeys: [] };
        var hasCatalog = false, sdKeys = [];
        cart.items.forEach(function (item) {
          if (propTruthy(item, FB.catalogProperty)) hasCatalog = true;
          if (propTruthy(item, FB.superDealProperty)) sdKeys.push(item.key);
        });
        return { hasCatalog: hasCatalog, sdKeys: sdKeys };
      })
      .catch(function () {
        /* On failure, keep current state rather than wrongly locking/removing */
        return { hasCatalog: document.body.classList.contains(FB.bodyClass), sdKeys: [] };
      });
  }

  /* Customer no longer qualifies (no Catálogo product) -> drop every Super
     Deal line item from the cart. */
  function removeSuperDeals(sdKeys) {
    var updates = {};
    sdKeys.forEach(function (k) { updates[k] = 0; });
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Keep the theme cart-count in sync; Rebuy re-reads the cart via its
           own fetch interceptor, and again whenever the flyout opens. */
        if (cart && typeof cart.item_count === 'number') {
          document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
        }
        try { document.dispatchEvent(new CustomEvent('rebuy:cart.change', { detail: cart })); } catch (e) {}
        return cart;
      })
      .catch(function () {});
  }

  var pendingRerun = false;

  function syncGate() {
    /* A call arriving while one is already in flight must not be silently
       dropped (e.g. the initial on-load reconcile can still be pending
       when an add-to-cart's fetch-hook trigger fires moments later) -
       queue it so the state is re-checked the instant the current call
       finishes, instead of leaving the gate one cart-change behind. */
    if (syncing) { pendingRerun = true; return; }
    syncing = true;
    computeCartState().then(function (state) {
      document.body.classList.toggle(FB.bodyClass, state.hasCatalog);
      /* Unlock transition: was locked, now unlocked -> celebrate once */
      if (state.hasCatalog && !lastHasCatalog && !popupShownThisSession) {
        showUnlockPopup();
        popupShownThisSession = true;
      }
      lastHasCatalog = state.hasCatalog;
      function finish() {
        syncing = false;
        if (pendingRerun) { pendingRerun = false; syncGate(); }
      }
      /* Enforcement: no qualifying Catálogo product but Super Deals are still
         in the cart -> remove them (customer no longer qualifies). */
      if (!state.hasCatalog && state.sdKeys.length) {
        removeSuperDeals(state.sdKeys).then(finish);
        return;
      }
      finish();
    });
  }

  /* --- Popup --- */
  var popupEl = null;

  function buildPopup() {
    if (popupEl) return popupEl;
    popupEl = document.createElement('div');
    popupEl.className = 'fb-popup';
    popupEl.setAttribute('role', 'dialog');
    popupEl.setAttribute('aria-modal', 'true');
    popupEl.setAttribute('aria-label', FB.copy.title);
    popupEl.innerHTML =
      '<div class="fb-popup__overlay" data-fb-popup-close></div>' +
      '<div class="fb-popup__panel">' +
        '<button type="button" class="fb-popup__close" aria-label="Cerrar" data-fb-popup-close>&times;</button>' +
        '<div class="fb-popup__emoji">' + FB.copy.emoji + '</div>' +
        '<h2 class="fb-popup__title">' + FB.copy.title + '</h2>' +
        '<p class="fb-popup__text">' + FB.copy.text + '</p>' +
        '<div class="fb-popup__actions">' +
          '<a href="' + FB.superDealsUrl + '" class="fb-popup__cta btn-fill">' + FB.copy.cta + '</a>' +
          '<button type="button" class="fb-popup__dismiss" data-fb-popup-close>' + FB.copy.dismiss + '</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(popupEl);

    popupEl.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-fb-popup-close')) {
        closePopup();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popupEl && popupEl.classList.contains('is-open')) {
        closePopup();
      }
    });
    return popupEl;
  }

  function showUnlockPopup() {
    buildPopup();
    /* Give Rebuy a beat to finish opening its flyout, then close it
       and reveal the popup as the single focus. (The body-class
       observer above will likely have already closed it by now — this
       is a second, redundant pass for the unlock case specifically.)
       No requestAnimationFrame here: rAF is suspended in a backgrounded
       tab, and by this point (260ms after buildPopup appended the
       element) the browser has long since painted its initial closed
       state, so the transition still animates cleanly without it. */
    setTimeout(function () {
      hideRebuyCart();
      popupEl.classList.add('is-open');
    }, 260);
  }

  function closePopup() {
    if (popupEl) popupEl.classList.remove('is-open');
  }

  /* --- Watch the cart --- */
  function watchCartCount() {
    var counts = document.querySelectorAll('.cart-count');
    if (!counts.length) return;
    var debounce = null;
    var observer = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(syncGate, 180);
    });
    counts.forEach(function (el) {
      observer.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  function init() {
    watchCartCount();
    /* Reconcile once on load in case server class and live cart differ */
    syncGate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   FB VARIANT AVAILABILITY — grey out OOS size×color combinations
   ------------------------------------------------------------
   Liquid's `value.available` is GLOBAL (available in ANY variant),
   so a size that is sold out in the chosen color still looks
   selectable. This re-evaluates each option value while holding the
   chosen COLOR fixed: sizes that have no in-stock variant in the
   chosen color get `.disabled`, while colors stay freely selectable
   (so shoppers can browse every colorway). The color option is
   detected by name, so it works regardless of option order (this
   store lists Talla first, Color second).

   The theme's own picker (product-options-picker.js) already
   ignores clicks on `.disabled` items, so this fully blocks
   selecting an out-of-stock combination via mouse or keyboard.
   Runs on load, after every `product:variantChange` (the picker
   re-renders the option list, wiping our classes), and when a
   picker is inserted async (quickview).
   ============================================================ */
(function () {
  'use strict';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var cache = {};

  function handleFromEl(po) {
    var url = (po && po.dataset && po.dataset.productUrl) || '';
    var m = url.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function normNames(opts) {
    if (!opts || !opts.length) return [];
    return (typeof opts[0] === 'string') ? opts.slice() : opts.map(function (o) { return o.name; });
  }

  function load(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        cache[handle] = { names: normNames(p.options), variants: p.variants || [] };
        return cache[handle];
      })
      .catch(function () { cache[handle] = { names: [], variants: [] }; return cache[handle]; });
  }

  function isColorName(name) {
    return String(name || '').toLowerCase().indexOf('color') >= 0;
  }

  function apply(po, data) {
    if (!data || !data.variants.length || !data.names.length) return;

    var lists = po.querySelectorAll('ul[data-option-name]');
    if (!lists.length) return;

    /* Currently-chosen value for each option */
    var chosen = {};
    lists.forEach(function (ul) {
      var ch = ul.querySelector('.product-option-picker__list-item.chosen');
      if (ch) chosen[ul.dataset.optionName] = ch.getAttribute('data-option-value');
    });

    lists.forEach(function (ul) {
      var name = ul.dataset.optionName;
      var idx = data.names.indexOf(name);
      if (idx < 0) return;

      ul.querySelectorAll('.product-option-picker__list-item').forEach(function (li) {
        var val = li.getAttribute('data-option-value');
        var ok = data.variants.some(function (v) {
          if (!v.available) return false;
          if (String(v.options[idx]) !== String(val)) return false;
          /* Constrain only by the chosen COLOR option(s), never by size,
             so colors stay freely selectable and sizes reflect the color. */
          for (var n in chosen) {
            if (n === name || !isColorName(n)) continue;
            var j = data.names.indexOf(n);
            if (j < 0) continue;
            if (String(v.options[j]) !== String(chosen[n])) return false;
          }
          return true;
        });
        if (!ok) {
          li.classList.add('disabled');
          li.setAttribute('aria-disabled', 'true');
          var input = li.querySelector('input');
          if (input) { input.classList.add('disabled'); input.disabled = true; }
        }
      });
    });
  }

  function applyAll() {
    document.querySelectorAll('product-options').forEach(function (po) {
      var handle = handleFromEl(po);
      if (!handle) return;
      load(handle).then(function (data) { apply(po, data); });
    });
  }

  document.addEventListener('product:variantChange', function () {
    requestAnimationFrame(applyAll);
  });

  /* Async-inserted pickers (quickview) */
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; applyAll(); });
  }
  var obs = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var k = 0; k < added.length; k++) {
        var n = added[k];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches('product-options')) || (n.querySelector && n.querySelector('product-options'))) {
          schedule();
          return;
        }
      }
    }
  });

  function start() {
    applyAll();
    if (document.body) obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
